/** Browser events for invisible blue-green SPA handoff. */

export const HUB_SERVER_DRAINING_EVENT = "hub:server-draining";

/** Lifecycle SSE reconnected through the public hub URL after drain or blip. */
export const HUB_LIFECYCLE_RECONNECTED_EVENT = "hub:lifecycle-reconnected";

export type HubLifecycleSseEvent = { phase: "connected" } | { phase: "server_draining" };

export function parseHubLifecycleSseDataLine(line: string): HubLifecycleSseEvent | null {
  if (!line.startsWith("data: ")) {
    return null;
  }
  const payload = line.slice("data: ".length).trim();
  if (payload === "") {
    return null;
  }
  try {
    return JSON.parse(payload) as HubLifecycleSseEvent;
  } catch {
    return null;
  }
}

export function signalHubServerDraining(): void {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  window.dispatchEvent(new CustomEvent(HUB_SERVER_DRAINING_EVENT));
}

export function signalHubLifecycleReconnected(): void {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  window.dispatchEvent(new CustomEvent(HUB_LIFECYCLE_RECONNECTED_EVENT));
}

export function onHubServerDraining(listener: () => void): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }
  window.addEventListener(HUB_SERVER_DRAINING_EVENT, listener);
  return () => {
    window.removeEventListener(HUB_SERVER_DRAINING_EVENT, listener);
  };
}

export function onHubLifecycleReconnected(listener: () => void): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }
  window.addEventListener(HUB_LIFECYCLE_RECONNECTED_EVENT, listener);
  return () => {
    window.removeEventListener(HUB_LIFECYCLE_RECONNECTED_EVENT, listener);
  };
}
